import axios from 'axios'

export const BASE_URL = import.meta.env.VITE_API_URL ?? window.env.API_URL

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Está = NULL porque  Não precisa tratar a resposta de sucesso
api.interceptors.response.use(null, (error) => {
  const token = sessionStorage.getItem('token')
  const errorData = error.response?.data.message

  if (
    token &&
    error.response?.status === 401 &&
    errorData === 'invalid or expired jwt'
  ) {
    sessionStorage.clear()
    window.location.href = '/login'
  }

  return Promise.reject(error)
})

api.interceptors.request.use((config) => {
  config.headers.Accept = 'application/json'

  const token = sessionStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export default api
